import { abandonmentTriggerCallback } from '../../../helpers';

/**
 * @see {@link modForm.triggerAbandonmentExperience} in modform.abandonment.jsdocs.js for full type definition
 * @returns {void}
 */
export function triggerAbandonmentExperience() {
	document.querySelector('body').addEventListener('mouseleave', abandonmentTriggerCallback);
}
